const MAX_CAPTURE_WIDTH = 640

export function findVideoElement(container: HTMLElement): HTMLVideoElement | null {
  const video = container.querySelector('video')
  return video instanceof HTMLVideoElement ? video : null
}

export function isVideoFrameReady(video: HTMLVideoElement): boolean {
  return video.videoWidth > 0 && video.videoHeight > 0
}

export function captureVideoFrameAsDataUrl(
  video: HTMLVideoElement,
  mimeType = 'image/jpeg',
  quality = 0.85,
): string {
  if (!isVideoFrameReady(video)) {
    throw new Error('Video frame dimensions not available')
  }

  const scale = Math.min(1, MAX_CAPTURE_WIDTH / video.videoWidth)
  const width = Math.round(video.videoWidth * scale)
  const height = Math.round(video.videoHeight * scale)

  const canvas = document.createElement('canvas')
  canvas.width = width
  canvas.height = height
  const ctx = canvas.getContext('2d')
  if (!(ctx instanceof CanvasRenderingContext2D)) {
    throw new Error('Canvas 2D context not available')
  }
  ctx.drawImage(video, 0, 0, width, height)
  return canvas.toDataURL(mimeType, quality)
}
